
import { Injectable } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';

@Injectable({
  providedIn: 'root'
})
export class MemberListCacheService {
  private branchId: string | null = null;
  private members: IMember[] | null = null;

  setMembers(branchId: string, members: IMember[]): void {
    this.branchId = branchId;
    this.members = [...members];
  }

  getMembers(branchId: string): IMember[] | null {
    if (this.branchId !== branchId || !this.members) {
      return null;
    }

    return [...this.members];
  }

  updateMember(
    branchId: string,
    memberId: string,
    changes: Partial<IMember>
  ): boolean {
    if (this.branchId !== branchId || !this.members) {
      return false;
    }

    const index = this.members.findIndex(
      member => String(member._id) === memberId
    );

    if (index === -1) {
      return false;
    }

    this.members[index] = {
      ...this.members[index],
      ...changes
    };

    return true;
  }

  clear(): void {
    this.branchId = null;
    this.members = null;
  }

  hasCache(branchId: string): boolean {
    return this.branchId === branchId && this.members !== null;
  }
}